import { useEffect } from 'react'

import { Navigate } from 'react-router'

import { useLogin } from '@tribeplatform/react-components/common'
import { useAuthMember } from '@tribeplatform/react-sdk/hooks'

import { BC } from '../../types/index.js'

import { ContentModuleComposer } from './ContentModuleComposer.js'
import { ContentTypeSelector } from './ContentTypeSelector.js'
import { PostComposer } from './PostComposer.js'
import { ComposerProps } from './types.js'
import { useComposer } from './useComposer.js'

export const Block: BC<ComposerProps> = (props: ComposerProps) => {
  const { new: isNew, postPath, eventPath } = props
  const { isGuest } = useAuthMember()
  const { showLogin } = useLogin()
  const {
    selectedSpace,
    composableContentTypes,
    shouldRenderContentTypeSelector,
    shouldRenderContentModuleForm,
    onCancel,
    postTypeSlug,
    contentModuleType,
  } = useComposer({ composerProps: props })

  useEffect(() => {
    if (isGuest) {
      showLogin(true)
    }
  }, [isGuest, showLogin])

  if (composableContentTypes.length === 0 && isNew) {
    return <Navigate to="/" replace />
  }

  if (shouldRenderContentTypeSelector) {
    return (
      <ContentTypeSelector
        composableContentTypes={composableContentTypes}
        space={selectedSpace}
        onCancel={onCancel}
      />
    )
  }

  if (shouldRenderContentModuleForm) {
    return (
      <ContentModuleComposer
        contentModuleType={contentModuleType}
        eventPath={eventPath}
        onCancel={onCancel}
        selectedSpace={selectedSpace}
      />
    )
  }

  return (
    <PostComposer
      isNew={isNew}
      postPath={postPath}
      onCancel={onCancel}
      selectedSpace={selectedSpace}
      postTypeSlug={postTypeSlug}
    />
  )
}
